import React from 'react';
import {
    FaFile
  } from 'react-icons/fa';
  
  import { MdKeyboardArrowDown } from 'react-icons/md';
  
  import { NavLink } from 'react-router-dom';
  import {
    // UncontrolledTooltip,
    Collapse,
    NavItem,
    NavLink as BSNavLink,
  } from 'reactstrap';
  import bn from '../../utils/bemnames';

  const bem = bn.create('sidebaritem');
  class SidebarItem extends React.Component {
    state = { IsOpen : true }
    render() { 
        return(
            <>
            <NavItem
              className={bem.e('nav-item')}
              onClick={()=> {
                  this.setState({...this.state, IsOpen : !this.state.IsOpen})
              }}
            >
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <FaFile  className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">{this.props.Title}</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.IsOpen
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.IsOpen}>
              {this.props.Items.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className="text-uppercase"
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>
            </>

        )
    }

}
export default SidebarItem